import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'
import {DalogActionDto} from '../../../types'

export const DalogActionQueryKey = 'dalog-action'

const INTERVAL_PERIOD_IN_MS = 30_000

type Params = {
  plantUpmId: string
  externalId: string
}

export const useDalogAction = (
  {plantUpmId, externalId}: Params,
  options?: UseQueryOptions<DalogActionDto, AxiosError>
) => {
  const path = `${TasksApiPath.DALOG_ACTIONS}/${plantUpmId}/dalog-actions/${externalId}`

  return useQuery<DalogActionDto, AxiosError>({
    queryKey: [DalogActionQueryKey, externalId, plantUpmId],
    queryFn: async ({signal}) => {
      const {data} = await ApiClient.axiosInstance.get<DalogActionDto>(path, {signal})

      return data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    enabled: !!plantUpmId,
    ...options
  })
}
